<template>
	<div>
		<el-row :gutter="10">
			<el-col :xs="24" :sm="7">
				<div v-loading="loading" element-loading-text="获取数据中,请稍后" element-loading-spinner="el-icon-loading">
					<el-row :gutter="20">
						<el-col>
							<el-card style="padding-bottom:20px;">
								<el-col :xs="24" :sm="24" :md="24">
									<el-input v-model="keywords" size="mini" placeholder="输入关键字搜索" maxlength="30" clearable style="margin:5px" @change="Search()">
										<el-button slot="append" icon="el-icon-search" @click="Search()"></el-button>
									</el-input>
								</el-col>
							</el-card>
						</el-col>
					</el-row>
					<el-row style="margin-top:15px;">
						<el-card>
							<el-table :data="tableData" style="width: 100%; " stripe max-height="600">
								<el-table-column label="品名" sortable show-overflow-tooltip min-width="230">
									<template slot-scope="scope">
										<el-button v-if="scope.row.pk!=$route.params.id" type="text" @click="jumpTo('/prodashboard/', scope.row.pk, scope.row )">{{ scope.row.prod_name }}</el-button>
										<div v-else class="active">{{ scope.row.prod_name }}</div>
									</template>
								</el-table-column>	
								<el-table-column label="品牌" prop="prod_brand__brand_name" sortable show-overflow-tooltip />
								<el-table-column label="规格" prop="prop_spec" sortable show-overflow-tooltip />
							</el-table>
												<!-- 分页 -->
					<el-row class="paginator hidden-sm-and-down">
						<el-pagination
							background
							:current-page.sync="currentPage"
							layout="total, sizes, prev, next"
							:total="totalItems"
							:page-sizes="[20, 50, 100]"
							:page-size="pageSize"
							@current-change="handleCurrentChange"
							@size-change="handleSizeChange"						
						/>
					</el-row>

					<el-row class="paginator hidden-sm-and-up">
						<el-pagination
							background
							:current-page.sync="currentPage"
							layout="prev, next"
							:total="totalItems"
							:page-size="pageSize"
							@current-change="handleCurrentChange"
							@size-change="handleSizeChange"
							prev-text="上一页"
							next-text="下一页"
						/>
					</el-row>
						</el-card>
					</el-row>


				</div>
			</el-col>
			<el-col :xs="24" :sm="17">
				<el-card>
					<el-tabs v-model="activeName" @tab-click="handleClick" tab-position="top">
						<el-tab-pane name="first">
							<span slot="label">
								<i class="el-icon-s-help"></i>
								价格体系
							</span>
							<div>
								<transition name="el-fade-in-linear"><router-view :key="$route.fullPath" name="a" v-if="isRouterAlive" /></transition>
							</div>
						</el-tab-pane>
						<el-tab-pane name="second">
							<span slot="label">
								<i class="el-icon-s-marketing"></i>
								月用量
							</span>
							<div>
								<transition name="el-fade-in-linear"><router-view :key="$route.fullPath" name="b" v-if="isRouterAlive" /></transition>
							</div>
						</el-tab-pane>
					</el-tabs>
				</el-card>
			</el-col>
		</el-row>
		
		
		
	</div>
</template>
<script>
export default {
	data() {
		return {
			activeName: 'first',
			isRouterAlive: true
		};
	},
	methods: {
		//路由跳转
		jumpTo(name, id, data) {
			var fullpath = name + id + '/';
			this.$router.push({ path: fullpath });
			this.hospitalDetails = data;
		}
	}
};
</script>



<script>
export default {
	inject: ['reload', 'logout'],
	data() {
		return {
			tableData: [],
			keywords: '',
			ifFullScreen: false,
			formLabelWidth: '80px',
			totalItems: 100,
			currentPage: 1,
			pageSize: 20,
			activeName: 'first',
			isRouterAlive: true,
			loading:false,
			areaPricesDialogVisible:false,
			areaUsageDialogViaible:false
			
		};
	},
	mounted() {
		let that = this;
		this.getData('', that.currentPage, that.pageSize);
		that.ifFullScreen = document.body.clientWidth > 720 ? false : true;
	},
	methods: {
		//路由跳转
		jumpTo(name, id, data) {
			var fullpath = name + id + '/';
			this.$router.push({ path: fullpath });
			this.hospitalDetails = data;
		},
		//通用函数-获取数据
		getData(keywords, currentPage, pageSize) {
			var that = this;
			this.$axios
				.get('/apim/get/product/', {
					params: {
						keywords: keywords,
						currentpage: currentPage,
						pagesize: pageSize
					}
				})
				.then(function(response) {
					if (response.data.code == '401') {
						that.logout();
					} else {
						var temp_data = response.data.data;
						temp_data.forEach(el=>{
							el.activeTab = 'prodInfo'
						})
						that.tableData = response.data.data;
						that.totalItems = response.data.totalItemNum;
					}
				})
				.catch(function(error) {
					console.log(error);
				});
		},
		//通用功能 - 关键字搜索
		Search() {
			var that = this;
			this.getData(that.keywords, that.currentPage, that.pageSize);
		},
		
		//分页跳转
		handleCurrentChange(val) {
			var that = this;
			this.currentPage = val;
			this.getData(that.keywords, that.currentPage, that.pageSize);
		},
		//每页显示条数更改
		handleSizeChange(val) {
			var that = this;
			this.pageSize = val;
			this.getData(that.keywords, that.currentPage, that.pageSize);
		},
		//路由跳转
		jumpTo(name, id) {
			var fullpath = name + id + '/';
			this.$router.push({ path: fullpath });
		},
		handleClick(tab, event) {
			// console.log(tab, event);
		}
	}
};
</script>
